import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

const GoogleRating = () => {
  return (
    <div className="flex flex-col items-center text-center my-6">
      {/* Rating */}
      <div className="flex items-center gap-3 text-lg font-bold">
        <span className="text-green-600 text-3xl">4.9</span>
        <div className="flex text-yellow-400 text-2xl">
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStarHalfAlt />
        </div>
      </div>

      {/* Text */}
      <p className="text-[#0F172A] font-normal text-xl mt-1">Highly Rated On Google</p>
      <p className="text-[#2C3776] text-lg font-normal mt-">200+ Reviews</p>
    </div>
  );
};

export default GoogleRating;
